// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { AdminLoginAuthModeResponseDTO } from '../models';
import { LoginDTO } from '../models';
import { ResetPasswordDTO } from '../models';
import { TokenResponseDTO } from '../models';
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Complete INTERNAL admin Google OAuth via WorkOS and mint app JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAdminGoogleLogin(options: any = {}): RequestArgs {
            const localVarPath = `/v2/auth/admin-google/callback`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Public admin-legacy login auth mode (Google rollout + password hatch)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminLoginAuthMode(options: any = {}): RequestArgs {
            const localVarPath = `/v2/auth/admin-login-mode`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Login endpoint
         * @param {LoginDTO} loginDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginDTO: LoginDTO, options: any = {}): RequestArgs {
            // verify required parameter 'loginDTO' is not null or undefined
            if (loginDTO === null || loginDTO === undefined) {
                throw new RequiredError('loginDTO','Required parameter loginDTO was null or undefined when calling login.');
            }
            const localVarPath = `/v2/auth/login`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"LoginDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loginDTO !== undefined ? loginDTO : {}) : (loginDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * End the INTERNAL session in the cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutInternalSession(options: any = {}): RequestArgs {
            const localVarPath = `/v2/auth/internal-session/logout`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Redeem a one time session token for an access token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemOneTimeSessionToken(token: string, options: any = {}): RequestArgs {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling redeemOneTimeSessionToken.');
            }
            const localVarPath = `/v2/auth/redeem-one-time-session-token`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset password endpoint
         * @param {ResetPasswordDTO} resetPasswordDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPasswordDTO: ResetPasswordDTO, options: any = {}): RequestArgs {
            // verify required parameter 'resetPasswordDTO' is not null or undefined
            if (resetPasswordDTO === null || resetPasswordDTO === undefined) {
                throw new RequiredError('resetPasswordDTO','Required parameter resetPasswordDTO was null or undefined when calling resetPassword.');
            }
            const localVarPath = `/v2/auth/reset-password`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ResetPasswordDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(resetPasswordDTO !== undefined ? resetPasswordDTO : {}) : (resetPasswordDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset password request endpoint
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordRequest(email: string, options: any = {}): RequestArgs {
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling resetPasswordRequest.');
            }
            const localVarPath = `/v2/auth/reset-password-request`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue a new access token from the INTERNAL session cookie, or from the Remix admin server\'s handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreInternalSession(options: any = {}): RequestArgs {
            const localVarPath = `/v2/auth/internal-session/restore`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Set password and authenticate endpoint
         * @param {ResetPasswordDTO} resetPasswordDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword(resetPasswordDTO: ResetPasswordDTO, options: any = {}): RequestArgs {
            // verify required parameter 'resetPasswordDTO' is not null or undefined
            if (resetPasswordDTO === null || resetPasswordDTO === undefined) {
                throw new RequiredError('resetPasswordDTO','Required parameter resetPasswordDTO was null or undefined when calling setPassword.');
            }
            const localVarPath = `/v2/auth/set-password`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ResetPasswordDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(resetPasswordDTO !== undefined ? resetPasswordDTO : {}) : (resetPasswordDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Start INTERNAL admin Google OAuth via WorkOS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAdminGoogleLogin(options: any = {}): RequestArgs {
            const localVarPath = `/v2/auth/admin-google/start`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Complete INTERNAL admin Google OAuth via WorkOS and mint app JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAdminGoogleLogin(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).completeAdminGoogleLogin(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Public admin-legacy login auth mode (Google rollout + password hatch)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminLoginAuthMode(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminLoginAuthModeResponseDTO> {
            const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).getAdminLoginAuthMode(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Login endpoint
         * @param {LoginDTO} loginDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginDTO: LoginDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponseDTO> {
            const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).login(loginDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * End the INTERNAL session in the cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutInternalSession(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).logoutInternalSession(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Redeem a one time session token for an access token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemOneTimeSessionToken(token: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponseDTO> {
            const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).redeemOneTimeSessionToken(token, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Reset password endpoint
         * @param {ResetPasswordDTO} resetPasswordDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPasswordDTO: ResetPasswordDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).resetPassword(resetPasswordDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Reset password request endpoint
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordRequest(email: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).resetPasswordRequest(email, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Issue a new access token from the INTERNAL session cookie, or from the Remix admin server\'s handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreInternalSession(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponseDTO> {
            const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).restoreInternalSession(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set password and authenticate endpoint
         * @param {ResetPasswordDTO} resetPasswordDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword(resetPasswordDTO: ResetPasswordDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponseDTO> {
            const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).setPassword(resetPasswordDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Start INTERNAL admin Google OAuth via WorkOS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAdminGoogleLogin(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).startAdminGoogleLogin(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Complete INTERNAL admin Google OAuth via WorkOS and mint app JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAdminGoogleLogin(options?: any) {
            return AuthApiFp(configuration).completeAdminGoogleLogin(options)(axios, basePath);
        },
        /**
         * Public admin-legacy login auth mode (Google rollout + password hatch)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminLoginAuthMode(options?: any) {
            return AuthApiFp(configuration).getAdminLoginAuthMode(options)(axios, basePath);
        },
        /**
         * Login endpoint
         * @param {LoginDTO} loginDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginDTO: LoginDTO, options?: any) {
            return AuthApiFp(configuration).login(loginDTO, options)(axios, basePath);
        },
        /**
         * End the INTERNAL session in the cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutInternalSession(options?: any) {
            return AuthApiFp(configuration).logoutInternalSession(options)(axios, basePath);
        },
        /**
         * Redeem a one time session token for an access token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemOneTimeSessionToken(token: string, options?: any) {
            return AuthApiFp(configuration).redeemOneTimeSessionToken(token, options)(axios, basePath);
        },
        /**
         * Reset password endpoint
         * @param {ResetPasswordDTO} resetPasswordDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPasswordDTO: ResetPasswordDTO, options?: any) {
            return AuthApiFp(configuration).resetPassword(resetPasswordDTO, options)(axios, basePath);
        },
        /**
         * Reset password request endpoint
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordRequest(email: string, options?: any) {
            return AuthApiFp(configuration).resetPasswordRequest(email, options)(axios, basePath);
        },
        /**
         * Issue a new access token from the INTERNAL session cookie, or from the Remix admin server\'s handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreInternalSession(options?: any) {
            return AuthApiFp(configuration).restoreInternalSession(options)(axios, basePath);
        },
        /**
         * Set password and authenticate endpoint
         * @param {ResetPasswordDTO} resetPasswordDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword(resetPasswordDTO: ResetPasswordDTO, options?: any) {
            return AuthApiFp(configuration).setPassword(resetPasswordDTO, options)(axios, basePath);
        },
        /**
         * Start INTERNAL admin Google OAuth via WorkOS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAdminGoogleLogin(options?: any) {
            return AuthApiFp(configuration).startAdminGoogleLogin(options)(axios, basePath);
        },
    };
};

/**
 * AuthApi - interface
 * @export
 * @interface AuthApi
 */
export interface AuthApiInterface {
    /**
     * Complete INTERNAL admin Google OAuth via WorkOS and mint app JWT
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    completeAdminGoogleLogin(options?: any): AxiosPromise<{}>;

    /**
     * Public admin-legacy login auth mode (Google rollout + password hatch)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    getAdminLoginAuthMode(options?: any): AxiosPromise<AdminLoginAuthModeResponseDTO>;

    /**
     * Login endpoint
     * @param {LoginDTO} loginDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    login(loginDTO: LoginDTO, options?: any): AxiosPromise<TokenResponseDTO>;

    /**
     * End the INTERNAL session in the cookie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    logoutInternalSession(options?: any): AxiosPromise<{}>;

    /**
     * Redeem a one time session token for an access token
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    redeemOneTimeSessionToken(token: string, options?: any): AxiosPromise<TokenResponseDTO>;

    /**
     * Reset password endpoint
     * @param {ResetPasswordDTO} resetPasswordDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    resetPassword(resetPasswordDTO: ResetPasswordDTO, options?: any): AxiosPromise<object>;

    /**
     * Reset password request endpoint
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    resetPasswordRequest(email: string, options?: any): AxiosPromise<object>;

    /**
     * Issue a new access token from the INTERNAL session cookie, or from the Remix admin server\'s handle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    restoreInternalSession(options?: any): AxiosPromise<TokenResponseDTO>;

    /**
     * Set password and authenticate endpoint
     * @param {ResetPasswordDTO} resetPasswordDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    setPassword(resetPasswordDTO: ResetPasswordDTO, options?: any): AxiosPromise<TokenResponseDTO>;

    /**
     * Start INTERNAL admin Google OAuth via WorkOS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    startAdminGoogleLogin(options?: any): AxiosPromise<{}>;

}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
    /**
     * Complete INTERNAL admin Google OAuth via WorkOS and mint app JWT
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public completeAdminGoogleLogin(options?: any) {
        return AuthApiFp(this.configuration).completeAdminGoogleLogin(options)(this.axios, this.basePath);
    }

    /**
     * Public admin-legacy login auth mode (Google rollout + password hatch)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getAdminLoginAuthMode(options?: any) {
        return AuthApiFp(this.configuration).getAdminLoginAuthMode(options)(this.axios, this.basePath);
    }

    /**
     * Login endpoint
     * @param {LoginDTO} loginDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(loginDTO: LoginDTO, options?: any) {
        return AuthApiFp(this.configuration).login(loginDTO, options)(this.axios, this.basePath);
    }

    /**
     * End the INTERNAL session in the cookie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logoutInternalSession(options?: any) {
        return AuthApiFp(this.configuration).logoutInternalSession(options)(this.axios, this.basePath);
    }

    /**
     * Redeem a one time session token for an access token
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public redeemOneTimeSessionToken(token: string, options?: any) {
        return AuthApiFp(this.configuration).redeemOneTimeSessionToken(token, options)(this.axios, this.basePath);
    }

    /**
     * Reset password endpoint
     * @param {ResetPasswordDTO} resetPasswordDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetPassword(resetPasswordDTO: ResetPasswordDTO, options?: any) {
        return AuthApiFp(this.configuration).resetPassword(resetPasswordDTO, options)(this.axios, this.basePath);
    }

    /**
     * Reset password request endpoint
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetPasswordRequest(email: string, options?: any) {
        return AuthApiFp(this.configuration).resetPasswordRequest(email, options)(this.axios, this.basePath);
    }

    /**
     * Issue a new access token from the INTERNAL session cookie, or from the Remix admin server\'s handle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public restoreInternalSession(options?: any) {
        return AuthApiFp(this.configuration).restoreInternalSession(options)(this.axios, this.basePath);
    }

    /**
     * Set password and authenticate endpoint
     * @param {ResetPasswordDTO} resetPasswordDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public setPassword(resetPasswordDTO: ResetPasswordDTO, options?: any) {
        return AuthApiFp(this.configuration).setPassword(resetPasswordDTO, options)(this.axios, this.basePath);
    }

    /**
     * Start INTERNAL admin Google OAuth via WorkOS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public startAdminGoogleLogin(options?: any) {
        return AuthApiFp(this.configuration).startAdminGoogleLogin(options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for AuthApi
 * Import individual functions for optimal bundle size
 */
/**
 * Complete INTERNAL admin Google OAuth via WorkOS and mint app JWT
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function completeAdminGoogleLogin(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).completeAdminGoogleLogin(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Public admin-legacy login auth mode (Google rollout + password hatch)
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getAdminLoginAuthMode(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<AdminLoginAuthModeResponseDTO> {
    const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).getAdminLoginAuthMode(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Login endpoint
 * @param {LoginDTO} loginDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function login(
    loginDTO: LoginDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TokenResponseDTO> {
    const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).login(loginDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * End the INTERNAL session in the cookie
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function logoutInternalSession(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).logoutInternalSession(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Redeem a one time session token for an access token
 * @param {string} token 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function redeemOneTimeSessionToken(
    token: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TokenResponseDTO> {
    const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).redeemOneTimeSessionToken(token, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Reset password endpoint
 * @param {ResetPasswordDTO} resetPasswordDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function resetPassword(
    resetPasswordDTO: ResetPasswordDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).resetPassword(resetPasswordDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Reset password request endpoint
 * @param {string} email 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function resetPasswordRequest(
    email: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).resetPasswordRequest(email, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Issue a new access token from the INTERNAL session cookie, or from the Remix admin server\'s handle
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function restoreInternalSession(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TokenResponseDTO> {
    const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).restoreInternalSession(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Set password and authenticate endpoint
 * @param {ResetPasswordDTO} resetPasswordDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function setPassword(
    resetPasswordDTO: ResetPasswordDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TokenResponseDTO> {
    const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).setPassword(resetPasswordDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Start INTERNAL admin Google OAuth via WorkOS
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function startAdminGoogleLogin(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).startAdminGoogleLogin(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

